<template>
    <div class="contacts-map" ref="map"></div>
</template>

<script>
export default {
    name: 'contacts-map',
    props: {
        center: Array,
        coords: Array,
        zoom: {
            type: Number,
            default: 10
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    computed: {
        mapLocale () {
            let locale
            this.lang === 'en' ? locale = 'en_ES' : locale = 'ru_RU'

            return locale
        }
    },
    data () {
        return {
            isApiLoaded: false,
            map: undefined,
            key: '24f1bde5-5b31-4172-8954-346fbb6112a4'
        }
    },
    methods: {
        async init () {
            const map = this.$refs.map
            const apiScript = document.querySelector('script[src*="https://api-maps.yandex.ru/2.1/"]')
            if (!apiScript) {
                await this.addYandexApi()
            } else {
                this.isApiLoaded = true
            }

            if (this.isApiLoaded) {
                /* eslint-disable no-undef */
                await ymaps.ready()
                this.map = new ymaps.Map(map, {
                    zoom: this.zoom,
                    center: this.center,
                    controls: ['zoomControl']
                }, {
                    suppressMapOpenBlock: true
                })

                let point = new ymaps.Placemark(this.coords, {
                    balloonContent: false
                }, {
                    iconColor: '#ee7918'
                })

                this.map.geoObjects.add(point)
                this.map.behaviors.disable('scrollZoom')
            }
        },
        addYandexApi () {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script')
                script.async = true
                script.scr = `https://api-maps.yandex.ru/2.1/?apikey=${this.key}&lang=${this.mapLocale}`
                document.head.appendChild(script)
                script.onload = () => {
                    this.isApiLoaded = true
                    resolve()
                }
            })
        }
    },
    mounted () {
        this.init()
    },
    beforeDestroy () {
        this.map.destroy()
        const apiScript = document.querySelector('script[src*="https://api-maps.yandex.ru/2.1/"]')
        if (apiScript) apiScript.remove()
    }
}
</script>

<style lang="scss">
    .contacts-map {
        height: 100%;
        min-height: 300px;
    }
</style>
